import React from "react";
import { StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody } from "reactstrap";

type Props = {
    message: string;
};

export function ArchiveBody({ message }: Props) {
    return (
        <ModalBody>
            <StyledLabel
                className="pl-3 m-0"
                style={{ whiteSpace: "pre-line" }}
            >
                {message}
            </StyledLabel>
        </ModalBody>
    );
}
